export const messages = {
  en: {
    productSeckill: {
      queryCondition: 'Query Conditions',
      selectProductName: 'Please select product name',
      selectKillStartTime: 'Please select seckill start time',
      selectStatus: 'Please select status',
      query: 'Query',
      seckillProducts: 'Seckill Products',
      add: 'Add',
      productImage: 'Product Image',
      productName: 'Product Name',
      seckillPeriod: 'Seckill Period',
      killStartTime: 'Seckill Start',
      killEndTime: 'Seckill End',
      validPurchase: 'Valid Purchase',
      onePurchaseCount: 'One-time Purchase Quantity',
      killPrice: 'Seckill Price',
      singlePrice: 'Single Price',
      limit: 'Limit',
      status: 'Status',
      validPeriod: 'Valid Period',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteSeckill: 'Confirm to delete seckill',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      addSeckill: 'Add Seckill',
      editSeckill: 'Edit Seckill',
      selectProduct: 'Select Product',
      selectGroup: 'Please select group',
      selectSpec: 'Please select specification',
      seckillDesc: 'Seckill Description',
      seckillDescPlaceholder: 'Required, please enter seckill product description',
      killStartTimePlaceholder: 'Required, please select seckill start time',
      killEndTimePlaceholder: 'Required, please select seckill end time',
      killTimeRangeInvalid: 'Seckill end time must be later than start time',
      validPurchasePlaceholder: 'Required, please enter valid purchase count',
      onePurchaseCountPlaceholder: 'Required, please enter one-time purchase quantity',
      killPricePlaceholder: 'Required, please enter seckill price',
      limitPlaceholder: 'Required, please enter limit',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please enter start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please enter end time',
      statusPlaceholder: 'Required, please select status',
      open: 'Open',
      close: 'Close',
      save: 'Save',
      saveSuccess: 'Save successfully',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    productSeckill: {
      queryCondition: '查询条件',
      selectProductName: '请选择产品名称',
      selectKillStartTime: '请选择秒杀开始时间',
      selectStatus: '请选择状态',
      query: '查询',
      seckillProducts: '秒杀商品',
      add: '添加',
      productImage: '商品图片',
      productName: '产品名称',
      seckillPeriod: '秒杀时段',
      killStartTime: '秒杀开始',
      killEndTime: '秒杀结束',
      validPurchase: '有效期内购买',
      onePurchaseCount: '一次购买数量',
      killPrice: '秒杀金额',
      singlePrice: '单买金额',
      limit: '限量',
      status: '状态',
      validPeriod: '有效期',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      confirmOperation: '请确认您的操作',
      confirmDeleteSeckill: '确定删除秒杀',
      cancel: '取消',
      confirmDelete: '确认删除',
      addSeckill: '添加秒杀',
      editSeckill: '修改秒杀',
      selectProduct: '选择商品',
      selectGroup: '请选择分组',
      selectSpec: '请选择规格',
      seckillDesc: '秒杀简介',
      seckillDescPlaceholder: '必填，请填写秒杀产品简介',
      killStartTimePlaceholder: '必填，请选择秒杀开始时间',
      killEndTimePlaceholder: '必填，请选择秒杀结束时间',
      killTimeRangeInvalid: '秒杀结束时间必须晚于开始时间',
      validPurchasePlaceholder: '必填，请填写有效期内购买次数',
      onePurchaseCountPlaceholder: '必填，请填写一次购买数量',
      killPricePlaceholder: '必填，请填写秒杀金额',
      limitPlaceholder: '必填，请填写限量',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      statusPlaceholder: '必填，请选择状态',
      open: '开启',
      close: '关闭',
      save: '保存',
      saveSuccess: '保存成功',
      deleteSuccess: '删除成功'
    }
  }
}
